import React from "react";
import "./escanos.scss";

const Escanos = ({
  title,
  totalTitle,
  barChartTitle,
  data
}) => React.createElement("div", {
  className: "mod-escanos"
}, React.createElement("div", {
  className: "mod-escanos-header"
}, React.createElement("div", {
  className: "mod-escanos-provincia"
}, title), React.createElement("div", {
  className: "mod-escanos-total"
}, totalTitle), React.createElement("div", {
  className: "mod-escanos-reparto"
}, barChartTitle)), data.map(item => {
  return React.createElement("div", {
    key: item.name,
    className: "mod-escanos-content"
  }, React.createElement("div", {
    className: "mod-escanos-provincia"
  }, item.name), React.createElement("div", {
    className: "mod-escanos-total"
  }, item.value), React.createElement("div", {
    className: "mod-escanos-reparto"
  }, item.data.map(seat => React.createElement("div", {
    className: "partido",
    title: seat.name,
    key: seat.name,
    style: {
      width: "".concat(100 / item.value * seat.value, "%"),
      backgroundColor: seat.color
    }
  }, seat.value))));
}));

export default Escanos;